import type { PropsWithChildren } from 'react'

import { cn } from '@/lib/ui/style-helpers'

type RailHeaderRowProps = { className?: string } & PropsWithChildren

export const RailHeaderRow = ({ className, children }: RailHeaderRowProps) => (
  <div className={cn('flex h-8 items-center gap-3', className)}>{children}</div>
)
